<div class="card_location_int" id="card_location_int-{{ location.stationId }}">
    <div class="d-flex align-items-start justify-content-between">
        <div class="d-none d-md-flex align-items-start">
            <span class="card_index">{{ index }}</span>
            <div class="d-flex flex-column">
                <h3 class="car-title">{{ location.name }}</h3>
                <div class="d-flex card_info">
                    <div
                        class="img_container align-items-center d-flex justify-content-center"
                    >
                        <img
                            alt="tipo-oficina"
                            [src]="
                                location.locationType === 'AIRPORT'
                                    ? ('images/plane.png' | cdn)
                                    : ('images/car.png' | cdn)
                            "
                        />
                    </div>
                    <p class="card_description">
                        {{ getFormattedAddress() }}
                    </p>
                </div>
            </div>
        </div>
        <fe-button
            [style]="'tertiary'"
            [loading]="loadingSelectBranch"
            class="d-none d-md-block"
            (onClick)="clickMark()"
        >
            {{ 'fe-international-card-location-button-select' | translate }}
        </fe-button>
        <div class="d-flex flex-column d-md-none w-100 container-card-mobile">
            <div class="d-flex">
                <span class="card_index">{{ index }}</span>
                <h3 class="car-title">{{ location.name }}</h3>
            </div>

            <div class="d-flex card_info">
                <div
                    class="img_container align-items-center d-flex justify-content-center"
                >
                    <img
                        alt="tipo-oficina"
                        [src]="
                            location.locationType === 'AIRPORT'
                                ? ('images/plane.png' | cdn)
                                : ('images/car.png' | cdn)
                        "
                    />
                </div>
                <p class="card_description">
                    {{ getFormattedAddress() }}
                </p>
            </div>
            <fe-button
                [style]="'tertiary'"
                [loading]="loadingSelectBranch"
                class="d-grid d-md-none"
                (onClick)="clickMark()"
            >
                {{ 'fe-international-card-location-button-select' | translate }}
            </fe-button>
        </div>
    </div>
</div>
